/* eslint-disable no-param-reassign */
import { FETCH_STATUSES } from '../../../utils/fetchStatusUtils';

export default function createResourceSlice(options) {
  const { resource, repository } = options;

  return {
    initialState: {
      [resource]: {
        creatingStatus: FETCH_STATUSES.idle,
        errors: null,
      },
    },
    reducers: {
      createResourceStart(state) {
        state[resource].creatingStatus = FETCH_STATUSES.pending;
        state[resource].errors = null;
      },
      createResourceSuccess(state) {
        state[resource].creatingStatus = FETCH_STATUSES.fulfilled;
      },
      createResourceFail(state, { payload: { errors } }) {
        state[resource].creatingStatus = FETCH_STATUSES.failed;
        state[resource].errors = errors;
      },
      createResourceReset(state) {
        state[resource].creatingStatus = FETCH_STATUSES.idle;
        state[resource].errors = null;
      },
    },
    actionCreators(restDispatch) {
      return {
        createResource: async (...params) => {
          try {
            restDispatch('createResourceStart');
            await repository.create(...params);
            restDispatch('createResourceSuccess');
          } catch (errors) {
            const { response } = errors;
            const { data } = response;
            restDispatch('createResourceFail', data);
            throw errors;
          }
        },
        createResetResource: () => restDispatch('createResourceReset'),
      };
    },
    abstractSelector: (state) => {
      return {
        resource: state[resource],
      };
    },
  };
}
